import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './components/AuthContext.tsx';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import LandingPage from './pages/LandingPage.tsx';
import AlertDashboard from './pages/AlertDashboard.tsx';
import PitchDeck from './pages/PitchDeck.tsx';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export default function App() {
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pitch" element={<ProtectedRoute><PitchDeck /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><AlertDashboard /></ProtectedRoute>} />
            <Route path="*" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}
